import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $(document).on('click', '.cmp-settings a, a.cmp-settings', (e) => {
        e.preventDefault();

        if (window.hasOwnProperty('Cookiebot')) {
            window.Cookiebot.renew();
        }
    });
});
